<template>
    <div class="tpl-page-container">
        <SideBar></SideBar>
        <MainView></MainView>
    </div>
</template>

<script type="text/javascript">
    import SideBar from '@/components/common_components/side_bar/side_menu.vue'

    import MainView from '@/apps/plan/sub_components/quadrant_view.vue'

    import {mapActions} from 'vuex'
    import {mapState} from 'vuex'

    export default {
        components: {
            SideBar,
            MainView,
        },
        computed: {
            ...mapState({
                view_id: state => state.main.view_id
            })
        },
        methods: {
            ...mapActions({
                change_main_view: 'main/change_main_view'
            })
        },
        watch: {
            '$route': function () {
                this.change_main_view(this.$route.params.view_id)
                //     this.change_index_content(),
                // this.change_dashboard_content(this.$route.query)
            }
        },
        mounted: function () {
            this.change_main_view(this.$route.params.view_id)
        }
    }
</script>
<style type="text/css">
</style>
